export default __webpack_public_path__ + "static/media/internPink.cb82f04f.svg";